import { render } from "./editHobby.vue?vue&type=template&id=a7fdc43a"
import script from "./editHobby.vue?vue&type=script&lang=js"
export * from "./editHobby.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__